import Chance from 'chance';

const parseInt = value => Number.parseInt(value, 10);

const randomInt = () => new Chance().integer();

export const seed = parseInt(process.env.SEED) || randomInt();

export default new Chance(seed);
